import React from "react"
import { logout } from "../utils"
import {
  FiZap,
  FiFileText,
  FiLayout,
  FiType,
  FiUser,
  FiMail,
  FiSettings,
  FiCheck,
  FiPower,
  FiCheckCircle,
} from "react-icons/fi"
const getLinkObj = (LinkPros = {}) => {
  const init = {
    path: "#",
    text: "No Name",
    isChildren: false,
    childItems: {},
    icon: false,
    isActive: false,
    extraProperties: {},
    devider: false,
    addClasses: false,
    clickFunction: () => {},
  }
  return {
    ...init,
    ...LinkPros,
  }
}

export const MainMenuLinks = () => {
  return [
    getLinkObj({
      path: "/dashboard",
      text: "Dashboard",
      icon: <FiZap />,
    }),
    getLinkObj({
      path: "#",
      text: "My Profile",
      isChildren: true,
      icon: <FiFileText />,
      childItems: myProfileMenu(),
      isActive: true,
      attributes: {
        "data-toggle": "collapse",
        "data-target": "#pages_drp",
      },
    }),
    getLinkObj({
      path: "/services",
      text: "Services",
      icon: <FiLayout />,
    }),
    getLinkObj({
      path: "/resources",
      text: "Resources",
      icon: <FiType />,
      attributes: {
        "data-toggle": "collapse",
        "data-target": "#content_drp",
      },
      isChildren: true,
      childItems: resourcesMenu(),
    }),
    getLinkObj({
      path: "/login",
      text: "Login",
      icon: <FiType />,
    }),

    getLinkObj({
      path: "/article",
      text: "Article",
      icon: <FiPower />,
      devider: true,
    }),
  ]
}
export const myProfileMenu = () => {
  return [
    getLinkObj({
      path: "/user/edit",
      text: "Edit Profile",
      isActive: true,
    }),
    getLinkObj({
      path: "/user",
      text: "View Profile",
    }),
  ]
}

export const resourcesMenu = () => {
  return [
    getLinkObj({
      path: "#",
      text: " Campus Map",
    }),
    getLinkObj({
      path: "#",
      text: "Directory Phone Book",
    }),
  ]
}

export const AccountLinks = () => {
  return [
    getLinkObj({
      path: "/user",
      text: "Profile",
      icon: <FiUser />,
      iClassName: "dropdown-icon",
    }),
    getLinkObj({
      path: "/dashboard",
      text: "Inbox",
      icon: <FiMail />,
      iClassName: "dropdown-icon",
    }),
    getLinkObj({
      path: "/dashboard",
      text: "Settings",
      icon: <FiSettings />,
      iClassName: "dropdown-icon",
    }),
    getLinkObj({
      path: "/dashboard",
      text: "Online",
      icon: <FiCheck />,
      devider: true,
      addClasses: "",
      iClassName: "text-success",
    }),
    getLinkObj({
      path: "/dashboard",
      text: "Log out",
      icon: <FiPower />,
      devider: true,
      iClassName: "dropdown-icon",
      clickFunction: logout,
    }),
  ]
}

export const AccountProfileTabs = () => {
  return [
    getLinkObj({
      path: "/",
      text: "Personal",
      icon: <FiCheckCircle />,
      status: "Completed",
      tabType: "personal",
    }),
    getLinkObj({
      path: "/",
      text: "Summary",
      icon: <FiCheckCircle />,
      status: "Update",
      tabType: "summary",
    }),
    getLinkObj({
      path: "/",
      text: "Education",
      icon: <FiCheckCircle />,
      status: "Update",
      tabType: "education",
    }),
  ]
}

export const userRolesList = () => {
  return [
    {
      value: "st",
      label: "Student",
    },
    {
      value: "fa",
      label: "Faculty",
    },
    {
      value: "al",
      label: "Alumani",
    },
    {
      value: "wm",
      label: "Web Master",
    },
  ]
}
